import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonDialogSettings } from '../common-dialog-settings.interface';

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    standalone: false,
})
export class AlertDialogComponent implements OnInit {
    public constructor(
        public dialogRef: MatDialogRef<AlertDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public settings: CommonDialogSettings
    ) {}

    public ngOnInit(): void {}

    public onAceptar(): void {
        this.dialogRef.close();

        if (this.settings.onAceptar) {
            this.settings.onAceptar(true);
        }
    }
}
